import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import NearbyPartners from './NearbyPartners';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { colors } from '../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../constants/text';
import { formatPhone } from '../../../../../core/util/string';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { CDP_TOUCH_CLINIC_PHONE_NUMBER } from '../../../../../core/analytics/events';
import { smallerThanOrEqualTo } from '../../../../../core/util/styledComponents';
import { isBookable, isTraditionalLocation } from '../../../../../core/util/location';

export const CDP_CLICK_TO_CALL_MODAL = 'click to call';

const SmoothDialog = styled(Dialog)`
  -webkit-font-smoothing: antialiased;
`;

const ClickToCallContainer = styled.div`
  background-color: white;
  padding: 20px;
  display: block;
`;

const ContactHeader = styled.div`
  font-size: ${fontSize.hellaLarge};
  font-family: ${fontFamily.bold};
  color: ${colors.squid};
  text-align: center;
  margin: 0 auto;

  ${smallerThanOrEqualTo.md`
    font-size: ${fontSize.extraLarge}
  `}
`;

const FlavorText = styled.div`
  font-size: ${fontSize.default};
  font-family: ${fontFamily.book};
  color: ${colors.blueMonday};
  text-align: center;
  width: 280px;
  position: relative;
  margin: 10px auto 20px;

  ${smallerThanOrEqualTo.md`
    font-size: ${fontSize.mediumSmall}
  `}
`;

const Close = styled.div`
  width: 25px;
  height: 25px;
  position: relative;
  cursor: pointer;
  margin: 0 0 -10px auto;
  ${smallerThanOrEqualTo.md`
    margin 0 0 0 auto;
  `}

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.squid};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.squid};
  }
`;

const PhoneNumber = styled.a`
  width: 200px;
  text-align: center;
  border-radius: 3px;
  padding: 10px 0;
  margin: 0 auto;
  cursor: pointer;
  display: block;
  text-decoration: none;
  background-color: ${colors.theWhiteAlbum};
  color: ${colors.crunchBerry};
  font-size: ${fontSize.default};
  font-family: ${fontFamily.medium};
  border: 0.5px solid ${colors.ladyInRed};
  transition: all 200ms ease;

  &:hover {
    text-decoration: underline;
    border-color: ${colors.crunchBerry};
    background-color: ${colors.crunchBerry};
    color: ${colors.white};
  }
`;

class ClickToCall extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    nearbyPartnerClinics: PropTypes.arrayOf(PropTypes.object).isRequired,
    fetchPartnerClinics: PropTypes.func.isRequired,
    fullScreen: PropTypes.bool,
    onClose: PropTypes.func,
    open: PropTypes.bool,
  };

  trackPhoneClick = () => {
    const { phone, id, uclId } = this.props.location;
    const trackingProperties = {
      locationId: id,
      uclId,
      phone,
    };

    analyticsTrackEvent(CDP_TOUCH_CLINIC_PHONE_NUMBER, trackingProperties);
  };

  render() {
    const {
      nearbyPartnerClinics,
      fetchPartnerClinics,
      fullScreen,
      location,
      onClose,
      open,
    } = this.props;
    return (
      <SmoothDialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={fullScreen}>
        <ClickToCallContainer>
          <Close onClick={onClose} />
          <ContactHeader>Call to Book</ContactHeader>
          <FlavorText>
            Please call the clinic to make an appointment or to ask any questions.
          </FlavorText>
          <PhoneNumber onClick={this.trackPhoneClick} href={`tel:${location.phone}`}>
            +1 {formatPhone(location.phone)}
          </PhoneNumber>
        </ClickToCallContainer>
        {!isBookable(location) && !isTraditionalLocation(location) && (
          <NearbyPartners
            {...{
              nearbyPartnerClinics,
              location,
              fetchPartnerClinics,
              fullScreen,
            }}
          />
        )}
      </SmoothDialog>
    );
  }
}

export default withMobileDialog({ breakpoint: 'xs' })(ClickToCall);
